export default "__VITE_PUBLIC_ASSET__64e8444e__"